const LOCAL_STORAGE_COMPARE_KEY = "shopify-compare";
const LOCAL_STORAGE_COMPARE_META_KEY = "shopify-compare-meta";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const COMPARE_TOAST_ID = "compare-add-toast";
const COMPARE_TOAST_STYLE_ID = "compare-add-toast-style";

function getCompare() {
  const compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY);
  if (!compare) return [];

  return compare
    .split(LOCAL_STORAGE_DELIMITER)
    .map((item) => item.trim())
    .filter(Boolean);
}

function setCompare(handles) {
  const normalizedHandles = [...new Set(handles.filter(Boolean))];

  if (normalizedHandles.length) {
    localStorage.setItem(
      LOCAL_STORAGE_COMPARE_KEY,
      normalizedHandles.join(LOCAL_STORAGE_DELIMITER)
    );
  } else {
    localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);
  }

  pruneCompareMeta(normalizedHandles);
  if (!normalizedHandles.length) {
    hideCompareToast();
  }

  return normalizedHandles;
}

function updateCompare(handle) {
  const compare = getCompare();
  const indexInCompare = compare.indexOf(handle);
  let isAdded = false;

  if (indexInCompare === -1) {
    compare.push(handle);
    isAdded = true;
  } else {
    compare.splice(indexInCompare, 1);
  }

  setCompare(compare);
  return isAdded;
}

function compareContains(handle) {
  return getCompare().includes(handle);
}

function updateCompareCounter() {
  const compareItemCount = getCompare().length;
  document.querySelectorAll(".compare__count").forEach((singleItem) => {
    singleItem.innerText = compareItemCount;
  });
}

function toggleComparePageState() {
  const comparePage = document.querySelector(".compare-page");
  if (!comparePage) return;
  comparePage.classList.toggle("compare_exists", getCompare().length > 0);
}

function getCompareMeta() {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_COMPARE_META_KEY) || "{}");
  } catch (error) {
    return {};
  }
}

function setCompareMeta(metaByHandle) {
  try {
    localStorage.setItem(LOCAL_STORAGE_COMPARE_META_KEY, JSON.stringify(metaByHandle));
  } catch (error) {
    // Ignore storage quota and private mode errors.
  }
}

function pruneCompareMeta(activeHandles) {
  const metaByHandle = getCompareMeta();
  const activeHandleSet = new Set(activeHandles);
  let changed = false;

  Object.keys(metaByHandle).forEach((handle) => {
    if (activeHandleSet.has(handle)) return;
    delete metaByHandle[handle];
    changed = true;
  });

  if (changed) {
    setCompareMeta(metaByHandle);
  }
}

function getCompareToastMessages() {
  const language =
    document.documentElement.lang?.toLowerCase() ||
    window?.Shopify?.locale?.toLowerCase() ||
    "en";
  const isBulgarian = language.startsWith("bg");

  if (isBulgarian) {
    return {
      added: "Добавено за сравнение",
      viewCompare: "Към сравнение",
      close: "Затвори",
    };
  }

  return {
    added: "Added to compare",
    viewCompare: "View compare",
    close: "Close",
  };
}

function getComparePageUrl() {
  return `${getLocalizedShopRoot()}pages/compare`;
}

function ensureCompareToastStyles() {
  if (document.getElementById(COMPARE_TOAST_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = COMPARE_TOAST_STYLE_ID;
  style.textContent = `
    #${COMPARE_TOAST_ID} {
      position: fixed;
      left: 50%;
      bottom: 1.6rem;
      transform: translateX(-50%);
      width: min(92vw, 620px);
      background: #fff;
      color: #121212;
      border: 1px solid rgba(0, 0, 0, 0.14);
      border-radius: 10px;
      box-shadow: 0 10px 28px rgba(0, 0, 0, 0.2);
      padding: 1.2rem 1.4rem;
      z-index: 1200;
    }

    #${COMPARE_TOAST_ID}[hidden] {
      display: none !important;
    }

    #${COMPARE_TOAST_ID} .compare-toast__inner {
      display: flex;
      gap: 1rem;
      align-items: center;
    }

    #${COMPARE_TOAST_ID} .compare-toast__title {
      margin: 0 0 0.8rem;
      font-size: 1.4rem;
      font-weight: 600;
      line-height: 1.3;
    }

    #${COMPARE_TOAST_ID} .compare-toast__thumbs {
      display: flex;
      gap: 0.5rem;
      flex-wrap: wrap;
    }

    #${COMPARE_TOAST_ID} .compare-toast__thumb-item {
      position: relative;
      display: inline-flex;
      width: 40px;
      height: 40px;
    }

    #${COMPARE_TOAST_ID} .compare-toast__thumb,
    #${COMPARE_TOAST_ID} .compare-toast__thumb-fallback {
      width: 40px;
      height: 40px;
      border-radius: 6px;
      border: 1px solid rgba(0, 0, 0, 0.12);
      object-fit: cover;
      background: #f5f5f5;
      flex: 0 0 auto;
    }

    #${COMPARE_TOAST_ID} .compare-toast__thumb-fallback {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      font-weight: 700;
      text-transform: uppercase;
      color: #444;
    }

    #${COMPARE_TOAST_ID} .compare-toast__thumb-remove {
      position: absolute;
      top: -6px;
      right: -6px;
      width: 18px;
      height: 18px;
      border: none;
      border-radius: 50%;
      background: #d7263d;
      color: #fff;
      font-size: 1.2rem;
      font-weight: 700;
      line-height: 1;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      cursor: pointer;
      opacity: 0;
      transform: scale(0.85);
      transition: opacity 0.2s ease, transform 0.2s ease;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    }

    #${COMPARE_TOAST_ID} .compare-toast__thumb-item:hover .compare-toast__thumb-remove,
    #${COMPARE_TOAST_ID} .compare-toast__thumb-item:focus-within .compare-toast__thumb-remove {
      opacity: 1;
      transform: scale(1);
    }

    #${COMPARE_TOAST_ID} .compare-toast__actions {
      display: flex;
      align-items: center;
      gap: 0.8rem;
      margin-left: auto;
      flex-shrink: 0;
    }

    #${COMPARE_TOAST_ID} .compare-toast__link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 36px;
      padding: 0.6rem 1.1rem;
      border-radius: 6px;
      background: #ffd400;
      color: #121212;
      font-weight: 600;
      text-decoration: none;
      white-space: nowrap;
    }

    #${COMPARE_TOAST_ID} .compare-toast__close {
      width: 34px;
      height: 34px;
      border: 1px solid rgba(0, 0, 0, 0.18);
      border-radius: 50%;
      background: #fff;
      color: #121212;
      cursor: pointer;
      font-size: 1.9rem;
      line-height: 1;
      padding: 0;
    }

    @media screen and (max-width: 749px) {
      #${COMPARE_TOAST_ID} {
        bottom: 1rem;
        padding: 1rem;
        padding-right: 4.8rem;
      }

      #${COMPARE_TOAST_ID} .compare-toast__inner {
        flex-direction: column;
        align-items: flex-start;
      }

      #${COMPARE_TOAST_ID} .compare-toast__actions {
        width: 100%;
        margin-left: 0;
        justify-content: flex-start;
      }

      #${COMPARE_TOAST_ID} .compare-toast__close {
        position: absolute;
        top: 0.8rem;
        right: 0.8rem;
      }

      #${COMPARE_TOAST_ID} .compare-toast__thumb-remove {
        opacity: 1;
        transform: scale(1);
      }
    }
  `;

  document.head.appendChild(style);
}

function ensureCompareToast() {
  let toast = document.getElementById(COMPARE_TOAST_ID);
  if (toast) return toast;

  ensureCompareToastStyles();

  toast = document.createElement("div");
  toast.id = COMPARE_TOAST_ID;
  toast.hidden = true;
  toast.innerHTML = `
    <div class="compare-toast__inner">
      <div class="compare-toast__content">
        <p class="compare-toast__title"></p>
        <div class="compare-toast__thumbs"></div>
      </div>
      <div class="compare-toast__actions">
        <a class="compare-toast__link" href="#"></a>
        <button type="button" class="compare-toast__close" aria-label="Close">×</button>
      </div>
    </div>
  `;

  const closeButton = toast.querySelector(".compare-toast__close");
  if (closeButton) {
    closeButton.textContent = "×";
  }
  closeButton?.addEventListener("click", () => {
    hideCompareToast();
  });
  toast.addEventListener("click", (event) => {
    const removeButton = event.target.closest(".compare-toast__thumb-remove");
    if (!removeButton) return;

    event.preventDefault();
    removeCompareHandleFromToast(removeButton.dataset.productHandle);
  });

  document.body.appendChild(toast);
  return toast;
}

function hideCompareToast() {
  const toast = document.getElementById(COMPARE_TOAST_ID);
  if (!toast) return;
  toast.hidden = true;
}

function getFirstImageSource(rootElement, selectors) {
  if (!rootElement) return "";

  for (const selector of selectors) {
    const image = rootElement.querySelector(selector);
    const imageSource = getImageSourceFromNode(image);
    if (imageSource && !imageSource.startsWith("data:")) {
      return imageSource;
    }
  }

  return "";
}

function getImageSourceFromNode(node) {
  if (!node) return "";

  const directSources = [
    node.currentSrc,
    node.src,
    node.getAttribute?.("src"),
    node.dataset?.src,
    node.dataset?.original,
    node.dataset?.lazySrc,
  ];

  for (const source of directSources) {
    if (source) return source;
  }

  const srcset =
    node.getAttribute?.("srcset") ||
    node.dataset?.srcset ||
    node.dataset?.lazySrcset ||
    "";
  if (!srcset) return "";

  const firstSource = srcset.split(",")[0]?.trim() || "";
  return firstSource.split(" ")[0] || "";
}

function getCompareItemImage(compareButton) {
  const selectors = [
    ".product-grid-item__thumbnail img",
    ".product-grid-item__thumbnail source",
    ".product__media img",
    ".product__media source",
    ".product-featured-media img",
    ".product-featured-media source",
    ".media img",
    ".media source",
    "img",
    "source",
  ];
  const roots = [
    compareButton.closest(".product-grid-item"),
    compareButton.closest(".card-wrapper"),
    compareButton.closest(".product"),
    document.querySelector(".product__media-wrapper"),
    document.querySelector(".product__media-list"),
  ];

  for (const rootElement of roots) {
    const source = getFirstImageSource(rootElement, selectors);
    if (source) return source;
  }

  return "";
}

function collectCompareItemMeta(compareButton) {
  const title = normalizeSpecText(compareButton.dataset.productTitle || "");
  const image = getCompareItemImage(compareButton);

  return { title, image };
}

function saveCompareItemMeta(productHandle, compareItemMeta) {
  if (!productHandle) return;

  const hasTitle = Boolean(compareItemMeta?.title);
  const hasImage = Boolean(compareItemMeta?.image);
  if (!hasTitle && !hasImage) return;

  const metaByHandle = getCompareMeta();
  metaByHandle[productHandle] = {
    title: compareItemMeta.title || "",
    image: compareItemMeta.image || "",
  };
  setCompareMeta(metaByHandle);
}

async function fetchCompareItemMetaByHandle(productHandle) {
  if (!productHandle) return null;

  try {
    const response = await fetch(
      `${getLocalizedShopRoot()}products/${productHandle}.js`
    );
    if (!response.ok) return null;

    const productData = await response.json();
    const fetchedImage =
      productData?.featured_image || productData?.images?.[0] || "";
    const normalizedImage = fetchedImage.startsWith("//")
      ? `https:${fetchedImage}`
      : fetchedImage;

    return {
      title: normalizeSpecText(productData?.title || ""),
      image: normalizedImage,
    };
  } catch (error) {
    return null;
  }
}

function hydrateCompareItemMeta(productHandle) {
  const existingMeta = getCompareMeta()[productHandle] || {};
  if (existingMeta.image) return;

  fetchCompareItemMetaByHandle(productHandle).then((fetchedMeta) => {
    if (!fetchedMeta) return;
    if (!compareContains(productHandle)) return;

    const mergedMeta = {
      title: fetchedMeta.title || existingMeta.title || "",
      image: fetchedMeta.image || existingMeta.image || "",
    };

    if (!mergedMeta.image && !mergedMeta.title) return;

    saveCompareItemMeta(productHandle, mergedMeta);
    showCompareToast(productHandle);
  });
}

function renderCompareToastThumbnails(thumbsContainer, handles, metaByHandle, removeLabel) {
  thumbsContainer.innerHTML = "";

  handles.forEach((handle) => {
    const productMeta = metaByHandle[handle] || {};
    const title = productMeta.title || handle;
    const thumbItem = document.createElement("div");
    thumbItem.className = "compare-toast__thumb-item";
    thumbItem.title = title;

    if (productMeta.image) {
      const image = document.createElement("img");
      image.className = "compare-toast__thumb";
      image.src = productMeta.image;
      image.alt = title;
      image.loading = "lazy";
      thumbItem.appendChild(image);
    } else {
      const fallback = document.createElement("span");
      fallback.className = "compare-toast__thumb-fallback";
      fallback.textContent = (title || "?").slice(0, 1);
      fallback.title = title;
      thumbItem.appendChild(fallback);
    }

    const removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "compare-toast__thumb-remove";
    removeButton.dataset.productHandle = handle;
    removeButton.setAttribute("aria-label", `${removeLabel}: ${title}`);
    removeButton.title = removeLabel;
    removeButton.innerHTML = "&times;";
    thumbItem.appendChild(removeButton);

    thumbsContainer.appendChild(thumbItem);
  });
}

function syncCompareButtonsState() {
  document.querySelectorAll("compare-item button[data-product-handle]").forEach((button) => {
    const productHandle = button.dataset.productHandle;
    if (!productHandle) return;
    button.classList.toggle(BUTTON_ACTIVE_CLASS, compareContains(productHandle));
  });
}

function removeCompareHandleFromToast(productHandle) {
  if (!productHandle) return;
  if (!compareContains(productHandle)) return;

  const nextCompareHandles = getCompare().filter((handle) => handle !== productHandle);
  setCompare(nextCompareHandles);
  updateCompareCounter();
  toggleComparePageState();
  syncCompareButtonsState();
  showCompareToast();
}

function showCompareToast(addedHandle) {
  const compareHandles = getCompare();
  if (!compareHandles.length) {
    hideCompareToast();
    return;
  }

  const toast = ensureCompareToast();
  const messages = getCompareToastMessages();
  const removeLabel = messages.remove || "Remove";
  const metaByHandle = getCompareMeta();
  const addedTitle = metaByHandle[addedHandle]?.title;
  const toastTitle = toast.querySelector(".compare-toast__title");
  const toastThumbs = toast.querySelector(".compare-toast__thumbs");
  const compareLink = toast.querySelector(".compare-toast__link");
  const closeButton = toast.querySelector(".compare-toast__close");

  if (toastTitle) {
    if (addedHandle) {
      toastTitle.textContent = addedTitle
        ? `${messages.added}: ${addedTitle}`
        : messages.added;
    } else {
      toastTitle.textContent = `${messages.viewCompare} (${compareHandles.length})`;
    }
  }

  if (toastThumbs) {
    const visibleHandles = compareHandles.slice(-4).reverse();
    renderCompareToastThumbnails(
      toastThumbs,
      visibleHandles,
      metaByHandle,
      removeLabel
    );
  }

  if (compareLink) {
    compareLink.href = getComparePageUrl();
    compareLink.textContent = `${messages.viewCompare} (${compareHandles.length})`;
  }

  if (closeButton) {
    closeButton.setAttribute("aria-label", messages.close);
    closeButton.title = messages.close;
  }

  toast.hidden = false;
}

class CompareProduct extends HTMLElement {
  constructor() {
    super();
    this.onAddCompare = this.onAddCompare.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.onAddCompare);
    this.onAddActiveClass();
    updateCompareCounter();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onAddCompare);
  }

  onAddActiveClass() {
    const compareAddedButton = this.querySelector("button");
    if (!compareAddedButton) return;

    const productHandle = compareAddedButton.dataset.productHandle;
    if (!productHandle) {
      console.error(
        "[compare] Missing `data-product-handle` attribute. Failed to update the Compare."
      );
      return;
    }

    compareAddedButton.classList.toggle(
      BUTTON_ACTIVE_CLASS,
      compareContains(productHandle)
    );
  }

  onAddCompare() {
    const compareItem = this.querySelector("button");
    if (!compareItem) return;

    const productHandle = compareItem.dataset.productHandle;
    if (!productHandle) {
      console.error(
        "[compare] Missing `data-product-handle` attribute. Failed to update the Compare."
      );
      return;
    }

    const isAdded = updateCompare(productHandle);
    updateCompareCounter();
    toggleComparePageState();

    if (isAdded) {
      const compareItemMeta = collectCompareItemMeta(compareItem);
      saveCompareItemMeta(productHandle, compareItemMeta);
      showCompareToast(productHandle);
      hydrateCompareItemMeta(productHandle);
    }

    const grid = this.closest("[grid-compare]");
    if (grid) {
      this.closest(".product-grid-item")?.remove();
      return;
    }

    compareItem.classList.add("loading");
    setTimeout(() => {
      compareItem.classList.remove("loading");
      compareItem.classList.toggle(BUTTON_ACTIVE_CLASS, isAdded);
    }, 500);
  }
}

if (!customElements.get("compare-item")) {
  customElements.define("compare-item", CompareProduct);
}

function removeCompareItemFromTable(removeButton) {
  const table = document.querySelector("#compare-content");
  if (!table) return;

  const productId = removeButton.dataset.pid;
  if (!productId) return;

  table.querySelectorAll(`td[data-pid="${productId}"]`).forEach((item) => {
    item.remove();
  });

  table.querySelectorAll("tr.cp_prd-spec-row").forEach((row) => {
    if (!row.querySelector("td")) row.remove();
  });

  table.querySelectorAll("tr.cp_prd-spec-group-row").forEach((groupRow) => {
    let nextRow = groupRow.nextElementSibling;
    let hasSpecRow = false;

    while (
      nextRow &&
      !nextRow.classList.contains("cp_prd-spec-group-row") &&
      !nextRow.classList.contains("cp_prd_description") &&
      !nextRow.classList.contains("cp_prd_buy--proudct")
    ) {
      if (nextRow.classList.contains("cp_prd-spec-row")) {
        hasSpecRow = true;
        break;
      }
      nextRow = nextRow.nextElementSibling;
    }

    if (!hasSpecRow) groupRow.remove();
  });

  if (!table.querySelector("tr.cp_prd-spec-row")) {
    table.querySelectorAll("tr.cp_prd-spec-group-row").forEach((row) => row.remove());
  }

  updateOptionalRowsVisibility(table);
}

function setupCompareTableEvents() {
  const compareTable = document.querySelector("#compare-content");
  if (!compareTable) return;

  compareTable.addEventListener("click", (event) => {
    const removeButton = event.target.closest(".cp_remove--button");
    if (!removeButton) return;

    const productHandle = removeButton.dataset.productHandle;
    if (!productHandle) {
      console.error(
        "[compare] Missing `data-product-handle` attribute. Failed to update the Compare."
      );
      return;
    }

    updateCompare(productHandle);
    removeCompareItemFromTable(removeButton);
    updateCompareCounter();
    toggleComparePageState();
  });
}

function appendCompareData(sourceDocument, sourceSelector, destinationSelector) {
  const destination = document.querySelector(destinationSelector);
  if (!destination) return;

  sourceDocument.querySelectorAll(sourceSelector).forEach((item) => {
    destination.appendChild(item);
  });
}

function getLocalizedShopRoot() {
  const shopRoot = window?.Shopify?.routes?.root || "/";
  return shopRoot.endsWith("/") ? shopRoot : `${shopRoot}/`;
}

function normalizeSpecText(value) {
  return (value || "").replace(/\s+/g, " ").trim();
}

function isMissingSpecValue(value) {
  const normalized = normalizeSpecText(value).toLowerCase();
  return !normalized || normalized === "-" || normalized === "—" || normalized === "n/a";
}

function updateOptionalRowsVisibility(table) {
  if (!table) return;

  const descriptionRow = table.querySelector("tr.cp_prd_description");
  if (!descriptionRow) return;

  const descriptionCells = Array.from(
    descriptionRow.querySelectorAll("td.cp_prd_description")
  );
  const hasDescription = descriptionCells.some(
    (cell) => !isMissingSpecValue(cell.textContent)
  );

  descriptionRow.hidden = !hasDescription;
}

function collectSpecificationData(compareHTML) {
  const productIds = [];
  const specOrder = [];
  const specMeta = new Map();
  const groupOrder = [];
  const groupLabels = new Map();
  const specsByProduct = new Map();
  const blockedSpecKeys = new Set(["category", "core_category", "option_category"]);
  const blockedSpecNames = new Set(["category"]);

  compareHTML.querySelectorAll(".cp_prd-specs").forEach((specContainer) => {
    const productId = specContainer.dataset.pid;
    if (!productId) return;

    if (!productIds.includes(productId)) {
      productIds.push(productId);
    }

    if (!specsByProduct.has(productId)) {
      specsByProduct.set(productId, new Map());
    }

    const productSpecs = specsByProduct.get(productId);

    specContainer.querySelectorAll(".cp_prd-spec-item").forEach((specItem) => {
      const specName = normalizeSpecText(
        specItem.querySelector(".cp_prd-spec-name")?.textContent
      );
      const specKey = normalizeSpecText(specItem.dataset.specKey) || specName;
      const specGroup = normalizeSpecText(specItem.dataset.specGroup) || "details";
      const specGroupLabel =
        normalizeSpecText(specItem.dataset.specGroupLabel) || specGroup;
      const specValue =
        normalizeSpecText(specItem.querySelector(".cp_prd-spec-value")?.textContent) ||
        "-";

      if (!specName || !specKey) return;
      if (
        blockedSpecKeys.has(specKey.toLowerCase()) ||
        blockedSpecNames.has(specName.toLowerCase())
      ) {
        return;
      }

      if (!groupOrder.includes(specGroup)) {
        groupOrder.push(specGroup);
      }

      if (!groupLabels.has(specGroup)) {
        groupLabels.set(specGroup, specGroupLabel);
      }

      if (!specMeta.has(specKey)) {
        specMeta.set(specKey, { name: specName, group: specGroup });
        specOrder.push(specKey);
      }

      const existingValue = productSpecs.get(specKey);
      if (!existingValue) {
        productSpecs.set(specKey, specValue);
        return;
      }

      if (!existingValue.includes(specValue)) {
        productSpecs.set(specKey, `${existingValue}, ${specValue}`);
      }
    });
  });

  return {
    productIds,
    specOrder,
    specMeta,
    groupOrder,
    groupLabels,
    specsByProduct,
  };
}

function renderSpecificationRows(compareHTML) {
  const compareTable = document.querySelector("#compare-content");
  const specsInsertionRow = compareTable?.querySelector("tr.cp_prd_description");
  if (!compareTable || !specsInsertionRow) return;

  compareTable.querySelectorAll("tr.cp_prd-spec-row").forEach((row) => row.remove());
  compareTable
    .querySelectorAll("tr.cp_prd-spec-group-row")
    .forEach((row) => row.remove());

  const { productIds, specOrder, specMeta, groupOrder, groupLabels, specsByProduct } =
    collectSpecificationData(compareHTML);
  if (!productIds.length || !specOrder.length) return;

  const fragment = document.createDocumentFragment();

  groupOrder.forEach((groupKey) => {
    const groupSpecs = specOrder
      .filter((specKey) => specMeta.get(specKey)?.group === groupKey)
      .filter((specKey) => {
        return productIds.some((productId) => {
          const specValue = specsByProduct.get(productId)?.get(specKey);
          return !isMissingSpecValue(specValue);
        });
      });
    if (!groupSpecs.length) return;

    // Keep base details rows without a dedicated heading row.
    if (groupKey !== "details") {
      const groupRow = document.createElement("tr");
      groupRow.className = "cp_prd-spec-group-row";

      const groupCell = document.createElement("th");
      groupCell.colSpan = productIds.length + 1;
      groupCell.textContent = groupLabels.get(groupKey) || groupKey;
      groupRow.appendChild(groupCell);
      fragment.appendChild(groupRow);
    }

    groupSpecs.forEach((specKey) => {
      const row = document.createElement("tr");
      row.className = "cp_prd-spec-row";

      const headingCell = document.createElement("th");
      headingCell.scope = "col";
      headingCell.style.width = "218px";
      headingCell.textContent = specMeta.get(specKey)?.name || specKey;
      row.appendChild(headingCell);

      productIds.forEach((productId) => {
        const valueCell = document.createElement("td");
        valueCell.className = "cp_prd-spec-value";
        valueCell.dataset.pid = productId;
        valueCell.textContent = specsByProduct.get(productId)?.get(specKey) || "-";
        row.appendChild(valueCell);
      });

      fragment.appendChild(row);
    });
  });

  specsInsertionRow.before(fragment);
}

async function setupCompare() {
  const compare = getCompare();
  toggleComparePageState();

  const compareTable = document.querySelector("#compare-content");
  if (!compareTable) return;
  if (!compare.length) return;

  const localizedShopRoot = getLocalizedShopRoot();
  const requests = compare.map(async (handle) => {
    const productTileTemplateUrl = `${localizedShopRoot}products/${handle}?view=compare`;
    const response = await fetch(productTileTemplateUrl);
    if (!response.ok) return "";
    return response.text();
  });

  const responses = await Promise.all(requests);
  const compareProductCards = responses.filter(Boolean).join("");
  if (!compareProductCards) return;

  const compareHTML = new DOMParser().parseFromString(
    compareProductCards,
    "text/html"
  );

  appendCompareData(
    compareHTML,
    ".product-grid-item__thumbnail",
    "#compare-content tr.cp_prd-thumb"
  );
  appendCompareData(compareHTML, ".cp_prd-price", "#compare-content tr.cp_prd-price");
  appendCompareData(
    compareHTML,
    ".cp_prd-availability",
    "#compare-content tr.cp_prd-availability"
  );
  appendCompareData(
    compareHTML,
    ".cp_prd_description",
    "#compare-content tr.cp_prd_description"
  );
  appendCompareData(compareHTML, ".cp_prd-brand", "#compare-content tr.cp_prd-brand");
  renderSpecificationRows(compareHTML);
  appendCompareData(
    compareHTML,
    ".cp_prd_buy--proudct",
    "#compare-content tr.cp_prd_buy--proudct"
  );
  updateOptionalRowsVisibility(compareTable);
}

document.addEventListener("DOMContentLoaded", () => {
  updateCompareCounter();
  setupCompareTableEvents();
  setupCompare();
});
